import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { BackReducers } from './back.reducer';
import { BackFeatureKey } from './back.state';
import { BackAuthEffects } from './auth/auth.effects';
import { BackAuthEntitiesEffects } from './auth/entities/entities.effects';
import { BackAuthEntitiesExternalEffects } from './auth/entities/external/entities-external.effects';
import { BackAuthEntitiesInternalEffects } from './auth/entities/internal/entities-internal.effects';
import { BackAuthEntitiesGlobalEffects } from './auth/entities/global/entities-global.effects';
import { BackAuthUsersExternalEffects } from './auth/users/external/users-external.effects';
import { BackAuthUsersInternalEffects } from './auth/users/internal/users-internal.effects';
import { BackAuthUsersGlobalEffects } from '@apps/back/store/auth/users/global/users-global.effects';
import { BackMiscEffects } from './misc/misc.effects';
import { BackPrtgEffects } from './prtg/prtg.effects';
import { BackPataCopilEffects } from './pata/copils/copils.effects';
import { BackReptEffects } from './rept/rept.effects';
import { BackItsmEffects } from './itsm/itsm.effects';
import { BackBckpEffects } from './bckp/bckp.effects';

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        StoreModule.forFeature(
            BackFeatureKey,
            BackReducers
        ),
        EffectsModule.forFeature([
            BackAuthEffects,
            BackAuthEntitiesEffects,
            BackAuthEntitiesExternalEffects,
            BackAuthEntitiesInternalEffects,
            BackAuthEntitiesGlobalEffects,
            // BackAuthUsersEffects,
            BackAuthUsersExternalEffects,
            BackAuthUsersInternalEffects,
            BackAuthUsersGlobalEffects,
            BackMiscEffects,
            BackPrtgEffects,
            BackPataCopilEffects,
            BackReptEffects,
            BackItsmEffects,
            BackBckpEffects
        ])
    ]
})
export class BackAuthStoreModule
{ }
